import { Geolocation } from '../../domain/models'
import { IGeolocationProvider, INavigator } from '../../domain/providers/IGeolocationProvider'

class GeolocationProvider implements IGeolocationProvider {
  private readonly browserNavigator: INavigator

  constructor(browserNavigator: INavigator) {
    this.browserNavigator = browserNavigator
  }

  fetchGeolocation(): Promise<Geolocation> {
    return new Promise((resolve) => {
      if (this.browserNavigator.geolocation) {
        // Geolocation IS available
        this.browserNavigator.geolocation.getCurrentPosition(
          (position) => {
            resolve(
              new Geolocation({
                isSupportedByDevice: true,
                authorized: true,
                coordinates: {
                  longitude: position.coords.longitude,
                  latitude: position.coords.latitude
                }
              })
            )
          },
          (error) => {
            // Geolocation IS available but NOT authorized
            console.warn('Geolocation is available but not authorized: ', error)
            resolve(
              new Geolocation({
                isSupportedByDevice: true,
                authorized: false
              })
            )
          },
          {
            timeout: 20000
          }
        )
      } else {
        // Geolocation IS NOT available
        console.warn('Geolocation is not available on this device')
        resolve(
          new Geolocation({
            isSupportedByDevice: false
          })
        )
      }
    })
  }
}

export default GeolocationProvider
